import notFoundImage from '@/assets/images/mtel-404.png';

export default {
    data() {
        return {
            notFoundImage,
        };
    },
};
